var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_3496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51635 12.8878L3.31064 10.505C2.62416 9.48969 2.37582 8.28734 2.6118 7.1215C2.84778 5.95566 3.55202 4.90567 4.59358 4.16673C5.63513 3.4278 6.94313 3.05023 8.27438 3.1042C9.60562 3.15818 10.8695 3.64004 11.8311 4.46019C12.7926 5.28033 13.3864 6.38296 13.502 7.56305C13.6176 8.74315 13.2471 9.9204 12.4595 10.8759C11.6719 11.8315 10.5207 12.5002 9.22001 12.7579C7.9193 13.0156 6.55756 12.8447 5.388 12.2769L2.51635 12.8878",
    stroke: "#222222",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5713 8.61065L7.40427 7.38867L8.62625 8.61065L10.4592 7.38867",
    stroke: "#222222",
    strokeWidth: 0.916486,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_3496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6638,
    height: 14.6638,
    fill: "white",
    transform: "translate(0.68338 0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.c6342ddfb04549a245e7b48c0241a557.svg";
export { ForwardRef as ReactComponent };